import moment from 'moment'

export default {
  items: [],
  categories: [],
  searchParams: {
    categoryIds: [-1, 1, 2, 3],
    year: moment().year(),
    month: moment().month() + 1,
    status: 'all'
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/meetings/state.js